import { GetElementTypeFriendlyName } from './constants';

export function convertElementTagToName(element: Element) {
    const elementTagName = element?.tagName.toLowerCase() ?? "";

    return (GetElementTypeFriendlyName(element) ?? (elementTagName.length > 0 ? `<${elementTagName}>` : `No Selection`));
}

export function findImmediateChildren(parent: Element, expectedTagName: string) {
    const res: Element[] = [];
    expectedTagName = expectedTagName.trim().toLowerCase();

    for (const child of parent.children) {
        if (child.tagName.toLowerCase() === expectedTagName) {
            res.push(child);
        }
    }

    return res;
}

export function findImmediateChildOrAdd(parent: Element, namespace: string, expectedTagName: string, creatorFunc?: (el: Element) => Element) {
    let node = findImmediateChildren(parent, expectedTagName)[0];

    if (!node) {
        node = document.createElementNS(namespace, expectedTagName);
        if (creatorFunc) {
            node = creatorFunc(node);
        }
        parent.append(node);
    }

    return node;
}

export function appendSimpleElement(parent: Element, tagName: string, innerText?: string) {
    const el = document.createElement(tagName);
    if (innerText) {
        el.textContent = innerText;
    }
    parent.append(el);
    return el;
}

export function appendSimpleElementNS(parent: Element, namespace: string, tagName: string, innerText?: string) {
    const el = document.createElementNS(namespace, tagName);
    if (innerText) {
        el.textContent = innerText;
    }
    parent.append(el);
    return el;
}
